module.exports = __webpack_public_path__ + "static/media/copy.f76d5b3c.svg";